import script from "./PasteImageField.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasteImageField.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__